import type { MachineOeeBreakdownItem } from "@opus-dt/shared-types";
import { MachineMetric } from "./MachineMetric";

interface Props {
  item: MachineOeeBreakdownItem;
  worstAvailability?: boolean;
  worstQuality?: boolean;
  onClick?: () => void;
}

// Decomposição do OEE de UMA máquina: Disponibilidade + Qualidade + refugo.
// Desempenho aparece como "—" (em breve, fora de escopo) e NÃO há OEE composto por máquina.
export function MachineOeeBreakdown({ item, worstAvailability, worstQuality, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-col gap-1.5 rounded-md border p-3 text-left transition-colors hover:bg-muted/40 focus-visible:outline-none focus-visible:[box-shadow:var(--rd-shadow-focus)]"
    >
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">{item.machineName}</span>
        <span className="font-mono text-[11px] text-muted-foreground">refugo {item.scrapQty}</span>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <MachineMetric
          label="Disponib."
          value={item.availability}
          nullLabel="—"
          worst={worstAvailability}
        />
        <MachineMetric
          label="Qualidade"
          value={item.isProductionCounter ? item.quality : null}
          nullLabel={item.isProductionCounter ? "Insuficiente" : "n/a"}
          worst={worstQuality}
        />
        {/* Desempenho por máquina fora de escopo nesta versão (sem cadência ideal).*/}
        <div className="flex items-center gap-1.5">
          <span className="h-2 w-2 shrink-0 rounded-full bg-muted" aria-hidden />
          <span className="text-[11px] text-muted-foreground">Desempenho</span>
          <span className="text-xs text-muted-foreground">— (em breve)</span>
        </div>
      </div>
    </button>
  );
}
